import {
  MY_APPROVALS_STATUS_FILTERS,
  MyApprovalsStatusFilter,
  MyApprovalsTab,
} from '../Consts/list-my-approvals.const';

const AWAITING_IMPLIED_STATUS: MyApprovalsStatusFilter = 'all';

const HIDDEN_ON_ACTED: ReadonlyArray<MyApprovalsStatusFilter> = ['pending'];

export function approvalsStatusFiltersForTab(
  tab: MyApprovalsTab,
): ReadonlyArray<MyApprovalsStatusFilter> {
  if (tab === 'acted') {
    return MY_APPROVALS_STATUS_FILTERS.filter((status) => !HIDDEN_ON_ACTED.includes(status));
  }

  return MY_APPROVALS_STATUS_FILTERS;
}

export function approvalsStatusFilterVisibleForTab(tab: MyApprovalsTab): boolean {
  return tab !== 'awaiting';
}

export function normalizeApprovalsStatusForTab(
  tab: MyApprovalsTab,
  status: MyApprovalsStatusFilter,
): MyApprovalsStatusFilter {
  if (!approvalsStatusFilterVisibleForTab(tab)) {
    return AWAITING_IMPLIED_STATUS;
  }

  return approvalsStatusFiltersForTab(tab).includes(status) ? status : AWAITING_IMPLIED_STATUS;
}
